import React from "react";
import { useParams, Link } from "react-router-dom";
import { Reveal } from "@/components/Reveal";
import Seo from "@/components/Seo";

const EMAIL = "starsoxofficial@gmail.com";
const ADDRESS = "STARSOX · Nilay Kemer\nMittlerer Worthhagen 65\n58507 Lüdenscheid\nDeutschland";

const CONTENT = {
  impressum: {
    title: "Impressum",
    intro: "Angaben gemäß § 5 DDG (Digitale-Dienste-Gesetz).",
    sections: [
      { h: "Anbieterin", body: "STARSOX\nInhaberin: Nilay Kemer\nMittlerer Worthhagen 65\n58507 Lüdenscheid\nDeutschland" },
      { h: "Kontakt", body: `Telefon: 0176 20936840\nInstagram: @starsoxofficial\nE-Mail: ${EMAIL}\nWebsite: https://starsox.de` },
      { h: "Verantwortlich für den Inhalt (§ 18 Abs. 2 MStV)", body: "Nilay Kemer\nMittlerer Worthhagen 65\n58507 Lüdenscheid" },
      { h: "Verbraucherstreitbeilegung", body: "Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: https://ec.europa.eu/consumers/odr. Wir sind nicht verpflichtet und grundsätzlich nicht bereit, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen." },
    ],
  },
  datenschutz: {
    title: "Datenschutzerklärung",
    intro: "Der Schutz deiner personenbezogenen Daten ist uns wichtig. Diese Erklärung informiert über Art, Umfang und Zweck der Verarbeitung personenbezogener Daten auf starsox.de.",
    sections: [
      { h: "Verantwortliche", body: `${ADDRESS}\nTelefon: 0176 20936840\nE-Mail: ${EMAIL}` },
      { h: "Erhebung & Verarbeitung", body: "Wir verarbeiten personenbezogene Daten (z. B. Name, Anschrift, E-Mail) ausschließlich zur Abwicklung von Bestellungen, zur Bearbeitung von Anfragen sowie zur Erfüllung gesetzlicher Pflichten (Art. 6 Abs. 1 lit. b und c DSGVO)." },
      { h: "Zahlungsabwicklung", body: "Zahlungen werden über unseren Dienstleister Stripe (Stripe Payments Europe, Ltd.) abgewickelt. Die für die Zahlung erforderlichen Daten werden an Stripe übermittelt. Ergänzend gelten die Datenschutzbestimmungen von Stripe." },
      { h: "Server-Logfiles", body: "Beim Aufruf der Website werden automatisch technische Zugriffsdaten (z. B. IP-Adresse, Datum und Uhrzeit, aufgerufene Seite) in Server-Logfiles gespeichert. Dies dient der Sicherheit und dem stabilen Betrieb der Website." },
      { h: "Deine Rechte", body: "Du hast das Recht auf Auskunft, Berichtigung, Löschung, Einschränkung der Verarbeitung, Datenübertragbarkeit sowie Widerspruch. Zudem besteht ein Beschwerderecht bei einer Datenschutzaufsichtsbehörde." },
    ],
  },
  agb: {
    title: "Allgemeine Geschäftsbedingungen",
    intro: "Es gelten die nachfolgenden Allgemeinen Geschäftsbedingungen für alle Bestellungen über starsox.de.",
    sections: [
      { h: "1. Geltungsbereich", body: "Diese AGB gelten für alle Verträge zwischen STARSOX (Inhaberin: Nilay Kemer, Mittlerer Worthhagen 65, 58507 Lüdenscheid) und dem Kunden über den Online-Shop starsox.de." },
      { h: "2. Vertragsschluss", body: "Die Darstellung der Produkte stellt kein bindendes Angebot dar. Mit dem Absenden der Bestellung gibst du ein verbindliches Angebot ab. Der Vertrag kommt mit unserer Bestätigung bzw. mit der Ausführung der Bestellung zustande." },
      { h: "3. Preise & Versand", body: "Alle Preise verstehen sich inkl. gesetzlicher MwSt. Der Versand innerhalb Deutschlands kostet 4,19 €; ab einem Bestellwert von 50 € ist der Versand kostenlos." },
      { h: "4. Zahlung", body: "Die Zahlung erfolgt sicher über Stripe – u. a. per Kredit-/Debitkarte, PayPal, Klarna sowie Apple Pay und Google Pay." },
      { h: "5. Widerruf & Rückgabe", body: "Verbrauchern steht ein 14-tägiges Widerrufsrecht zu. Einzelheiten regelt die Widerrufsbelehrung." },
      { h: "6. Anwendbares Recht", body: "Es gilt das Recht der Bundesrepublik Deutschland unter Ausschluss des UN-Kaufrechts. Zwingende verbraucherschützende Vorschriften des Staates des gewöhnlichen Aufenthalts des Kunden bleiben unberührt." },
    ],
  },
  versand: {
    title: "Versand",
    intro: "Alle Informationen rund um Lieferung und Versand.",
    sections: [
      { h: "Liefergebiet", body: "Wir versenden aktuell ausschließlich innerhalb Deutschlands." },
      { h: "Versandkosten", body: "4,19 € pro Bestellung. Ab einem Bestellwert von 50 € liefern wir versandkostenfrei." },
      { h: "Lieferzeit", body: "Die Lieferung erfolgt in der Regel innerhalb von 2–3 Werktagen nach Zahlungseingang." },
    ],
  },
  rueckgabe: {
    title: "Rückgabe",
    intro: "Dein Einkauf – ohne Risiko.",
    sections: [
      { h: "14 Tage Rückgaberecht", body: "Du kannst ungetragene Artikel im Originalzustand innerhalb von 14 Tagen zurückgeben." },
      { h: "Ablauf", body: "Kontaktiere uns per E-Mail (starsoxofficial@gmail.com), telefonisch (0176 20936840) oder per Instagram (@starsoxofficial), um deine Rückgabe anzumelden." },
      { h: "Rücksendeadresse", body: ADDRESS },
    ],
  },
  widerruf: {
    title: "Widerrufsbelehrung",
    intro: "Verbraucher haben ein gesetzliches Widerrufsrecht.",
    sections: [
      { h: "Widerrufsrecht", body: "Du hast das Recht, binnen 14 Tagen ohne Angabe von Gründen diesen Vertrag zu widerrufen. Die Widerrufsfrist beträgt 14 Tage ab dem Tag, an dem du oder ein von dir benannter Dritter die Ware in Besitz genommen hat." },
      { h: "Ausübung des Widerrufs", body: `Um dein Widerrufsrecht auszuüben, musst du uns (STARSOX, Nilay Kemer, Mittlerer Worthhagen 65, 58507 Lüdenscheid, Telefon: 0176 20936840, E-Mail: ${EMAIL}) mittels einer eindeutigen Erklärung über deinen Entschluss informieren.` },
      { h: "Folgen des Widerrufs", body: "Im Falle eines wirksamen Widerrufs erstatten wir alle erhaltenen Zahlungen unverzüglich und spätestens binnen 14 Tagen zurück." },
      { h: "Muster-Widerrufsformular", body: `(Wenn du den Vertrag widerrufen möchtest, fülle dieses Formular aus und sende es zurück.)\n\nAn: STARSOX, Nilay Kemer, Mittlerer Worthhagen 65, 58507 Lüdenscheid, E-Mail: ${EMAIL}\n\nHiermit widerrufe ich/wir den von mir/uns abgeschlossenen Vertrag über den Kauf der folgenden Waren:\n\n– Bestellt am / erhalten am:\n– Name des/der Verbraucher(s):\n– Anschrift des/der Verbraucher(s):\n– Datum / Unterschrift (nur bei Mitteilung auf Papier)` },
    ],
  },
};

export default function Legal() {
  const { slug } = useParams();
  const data = CONTENT[slug];

  if (!data) {
    return (
      <div className="bg-ink pt-[140px] pb-40 container-x">
        <h1 className="font-heading text-5xl uppercase">Seite nicht gefunden</h1>
        <Link to="/" className="btn-ghost mt-8">Zurück zur Startseite</Link>
      </div>
    );
  }

  return (
    <div className="bg-ink pt-[110px] md:pt-[130px] pb-28" data-testid={`legal-${slug}`}>
      <Seo title={data.title} description={data.intro} path={`/legal/${slug}`} />
      <div className="container-x max-w-3xl">
        <Reveal>
          <p className="overline mb-4">Rechtliches</p>
          <h1 className="font-heading text-5xl md:text-7xl uppercase leading-[0.9]">{data.title}</h1>
          <p className="mt-6 text-white/50">{data.intro}</p>
        </Reveal>

        <div className="mt-12 space-y-10">
          {data.sections.map((s, i) => (
            <Reveal key={i} delay={i * 0.04}>
              <div className="border-t border-white/10 pt-8">
                <h2 className="font-heading text-xl md:text-2xl uppercase tracking-wide">{s.h}</h2>
                <p className="mt-3 text-white/60 leading-relaxed whitespace-pre-line">{s.body}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <p className="mt-14 text-white/30 text-xs">
          Stand: Die Angaben sind vollständig. Bei Fragen erreichst du uns unter starsoxofficial@gmail.com.
        </p>
      </div>
    </div>
  );
}
